<script>
    import R, {LOADER} from "../../lib/requests";
    import {clickOutside} from '../../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';
    import ColoredNameControl from "./ColoredNameControl.svelte";
    import AppIcon from "../icons/AppIcon.svelte";
    import TagsPopup from '../../tags/TagsPopup.svelte';
    import {OBJECTS} from "../../lib/constants";

    export let tags = [];
    export let clockingTask = false;
    export let service = false;
    export let inline = false;
    export let readonly = false;

    let results = [];
    let listIndex = -1;
    let objectType = null;
    let showDropdown = false;
    let showTagsPopup = false;

    const dispatch = createEventDispatcher();

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            event.stopPropagation();
            closeDropdown();
        }
    }

    const selectResult = (item) => {
        tags = [...tags, item];
        dispatch('change');
        closeDropdown();
    }

    const load = () => {
        const onSuccess = result => {
            results = [];
            result.map(item => {
                if (item.object_type == objectType && !tags.find(x => x.id == item.id)) {
                    results.push(item);
                }
            });
            // if (results.length) {
            openDropdown();
            // }
        }

        const onFailure = err => {
        };

        R.handle(R.tag.index, {}, onSuccess, onFailure);
    }

    const openDropdown = () => {
        if (!showDropdown) {
            showDropdown = true;
            document.addEventListener('keydown', handleEscapeKey);
        }
    }

    const closeDropdown = () => {
        if (showDropdown) {
            showDropdown = false;
            results = [];
            listIndex = -1;
            document.removeEventListener('keydown', handleEscapeKey);
        }
    }


    const onToggleDropdown = () => {
        if (!showDropdown) {
            load();
        } else {
            closeDropdown();
        }
    }


    const onRemoveTag = (item) => {
        tags = tags.filter(x => x.id != item.id);
        dispatch('change');
    }

    const openTagsEditPopup = () => {
        closeDropdown();
        showTagsPopup = true;
    }

    const closeTagsEditPopup = param => {
        showTagsPopup = false;

        if (param) {
            // update current tags
            let list = [];
            tags.map(tag => {
                let item = param.find(x => x.id == tag.id);
                if (item) {
                    list = [...list, item];
                }
            });
            tags = list;
            dispatch('change');
        }
    }

    if (clockingTask) {
        objectType = OBJECTS.CLOCKING_TASK;
    } else if (service) {
        objectType = OBJECTS.SERVICE;
    }
</script>

<div class="tags-control" class:inline={ inline } use:clickOutside on:click_outside="{ closeDropdown }">
    <div class="tags-content">
        {#if !readonly}
            <button class="btn btn-link ps-0" on:click={ onToggleDropdown }>
                <AppIcon icon="tag" size="18" strokeWidth="2" inline/>
                {#if !tags.length}
                    ετικέτες
                {/if}
            </button>
        {/if}
        {#each tags as item}
            <div class="tag" class:readonly={readonly} style="color: #{ item.color }">
                { item.name }
                {#if !readonly}
                    <div class="remove" on:click={ () => onRemoveTag(item) }>&times;</div>
                {/if}
            </div>
        {/each}
    </div>
    {#if showDropdown}
        <div class="control-dropdown">
            <ul>
                {#if results.length}
                    {#each results as item, index}
                        <li class="dropdown-item" class:active="{ listIndex === index }"
                            on:click="{ () => selectResult(item) }">
                            <ColoredNameControl name="{ item.name }" color="{ item.color }" colorName/>
                        </li>
                    {/each}
                {/if}
                <li class="dropdown-item edit" on:click={openTagsEditPopup}>
                    <div class="icon">
                        <AppIcon icon="edit"/>
                    </div>
                    Επεξεργασία
                </li>
            </ul>
        </div>
    {/if}
</div>

{#if showTagsPopup}
    <TagsPopup {objectType} closeCallback={closeTagsEditPopup}/>
{/if}

<style>
    .tags-control {
        position: relative;
    }

    .tags-control.inline {
        display: inline-block;
    }

    .tags-control .control-dropdown {
        position: absolute;
        width: max-content;
        min-width: 200px;
        background: var(--dropdown-background);
        box-shadow: var(--dropdown-box-shadow);
        z-index: 5000;
    }

    .tags-control .tags-content {
        display: flex;
        align-items: center;
    }

    .tags-control .tags-content .tag {
        position: relative;
        white-space: nowrap;
        padding: 2px 20px 2px 5px;
        margin-right: 5px;
        border: 1px solid #e4eaee;
        border-radius: 4px;
    }

    .tags-control .tags-content .tag.readonly {
        padding-right: 2px;
    }

    .tags-control .tags-content .tag .remove {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        font-size: 1rem;
        color: #bbb;
        padding: 0 5px;
        cursor: pointer;
    }

    .control-dropdown ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .control-dropdown ul > li.dropdown-item {
        cursor: pointer;
        padding: 10px 10px;
    }

    .control-dropdown ul > li.dropdown-item:hover,
    .control-dropdown ul > li.dropdown-item.active {
        background: var(--dropdown-item-hover-background);
    }

    .control-dropdown ul > li.dropdown-item.edit {
        display: flex;
        align-items: center;
        border-top: var(--dropdown-separator);
    }

    .control-dropdown ul > li.dropdown-item.edit .icon {
        width: 16px;
        margin-right: 10px;
    }

    /*.control-dropdown ul > li.dropdown-button {*/
    /*    text-align: center;*/
    /*    background: var(--dropdown-button-background);*/
    /*    cursor: pointer;*/
    /*    padding: 10px 20px;*/
    /*}*/

    .control-dropdown ul > li.separator {
        border-top: var(--dropdown-separator);
    }
</style>